import { Typography, Button} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import { useCallback, useState } from "react";
import { UBItem } from "./UBItem"

export const UBDailyFilter = ({value, onChange}) => {
    const [start, setStart] = useState(value?.start);
    const [end, setEnd] = useState(value?.end);

    const onApply = useCallback((e) => {
        onChange({ start: start.clone(), end: end.clone()});
    }, [end, onChange, start]);

    return (
        <UBItem styles={{display: 'flex', justifyContent: 'end', alignItems: 'center'}}>
            <Typography
                sx={{ mr: "auto", ml: 2 }}
                variant="h5"
                fontWeight="bold"
                align="left"
                alignSelf="center"
                component="div"
            >
                Filter
            </Typography>

            <DatePicker
                label="Start"
                value={start}
                onChange={newValue => setStart(newValue)}
                sx={{px: 1}}
            />

            <DatePicker
                label="End"
                value={end}
                onChange={newValue => setEnd(newValue)}
                sx={{pr: 1}}
            />

            <Button
                onClick={onApply}
                sx={{ color: 'white', borderColor: 'white', display: 'block', textTransform: 'none' }}
            >
                <Typography variant="h6" fontWeight="bold" align="left">Refresh</Typography>
            </Button>
        </UBItem>
    );
}